import React from "react";
import DataGridModule from "./datagrid/DataGridModule";

const Module = () => {
  return (
    <div>
      <div>
        <p className="h5 text-success pb-2 pt-2">Liste de modules</p>
      </div>
      <DataGridModule />
    </div>
  );
};

export default Module;
